import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';
import { library } from '@fortawesome/fontawesome-svg-core';
import { faUserTag } from '@fortawesome/free-solid-svg-icons';

import EnrollmentTable from '@activities/components/tables/enrollment-table/enrollment-table.vue';
import Vue from 'vue';
import { Component, Prop, Watch } from 'vue-property-decorator';
import { v4 as uuidv4 } from 'uuid';

library.add(faUserTag);

@Component({
  name: 'bpc-enrollment-container',
  components: {
    'bpc-enrollment-table': EnrollmentTable,
    '<font-awesome-icon': FontAwesomeIcon,
  },
})
export default class EnrollmentContainer extends Vue {
  $refs: {
    enrollmentTable: InstanceType<typeof EnrollmentTable> & {
      setStdFormData(index, value): void;
      onPageAction(event): void;
    };
  };

  @Prop(Object) readonly activityFormModel: AnyEntity;
  @Prop(Object) readonly groupFormModel: AnyEntity;
  @Prop({ type: Boolean }) readonly isLoading: boolean;

  //DATA

  // Enrollments state
  public enrollmentTableKey: string = 'enrollment-table-';
  public formConfigName: string = 'create-from-management';
  public editFormConfigName: string = 'edit-from-management';
  public displayConfigName: string = 'management-table';
  public filtersExcluded = ['type', 'activity_id', 'activity_group_id'];
  public extendedFilterConfigName: string = 'management-extended';
  public bulkEditFormConfigName: string = 'management-bulk-edit';

  // LIFECYCLE

  //mounted() {}

  // METHODS

  onCreateEnrollment() {
    this.$refs.enrollmentTable.onPageAction('create');
  }

  onModelLoaded($event) {
    //When the model is loaded we have to load by default he activity and the group on management.
    this.$refs.enrollmentTable.setStdFormData('activity_id', this.activityFormModel.id);
    this.$refs.enrollmentTable.setStdFormData('activity', this.activityFormModel);
    this.$refs.enrollmentTable.setStdFormData('activity_group_id', this.groupFormModel.id);
    this.$refs.enrollmentTable.setStdFormData('activityGroup', this.groupFormModel);
  }

  // WATCHERS
  //TODO: discuss about the best way to refresh table on route change or on model change.
  /*
  @Watch('$route')
  onChangeRoute() {
    setTimeout(() => {
      if (this.$refs.enrollmentTable ){
        this.$refs.enrollmentTable.onRefresh();
      }
    });
  }
*/

  @Watch('groupFormModel', { immediate: true, deep: true })
  onGroupChanged() {
    setTimeout(() => {
      if (this.$refs.enrollmentTable) {
        this.$refs.enrollmentTable.onRefresh();
      }
    });
  }
}
